<template>
    <div class="page bg-history relative desktop-footer">
        <div class="bg-head-coin hidden sm:block"></div>
        <div class="page-content sm:px-8 pb-0">
            <TopBar class="hidden sm:block" title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <TopBarBack class="block sm:hidden bg-a-blue-1c3e95 "></TopBarBack>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 sm:mt-4 rounded-25 flex flex-col">
                <div class="bg-white sm:rounded-25 p-6 pb-3 h-full flex-1 wrapper">
                    <PathLink :campaignName="lbl.home.tab_menu.history"></PathLink>
                    <div class="sm:mx-20">
                        <div class="text-24 text-tc-blue-1 text-center font-main-medium pb-4">{{lbl.history.title}}</div>
                        <Menutab @onClick="changeTabToGetHistoryRedeem($event)"></Menutab>
                        <div class="flex justify-center" v-show="selectTab === 0 || selectTab === 2">
                            <div>
                                <DateDropdown @onChange="onSelectDate($event)"/>
                            </div>
                        </div>
                        <div v-show="selectTab === 0">
                            <HistoryRedeemReceiveList :list="historyReceiveList" :modalController="modalController"></HistoryRedeemReceiveList>
                        </div>
                        <div v-show="selectTab === 1">
                            <HistoryRedeemUseList :list="historyUseList" :modalController="modalController"></HistoryRedeemUseList>
                        </div>
                        <div v-show="selectTab === 2">
                            <HistoryTranferList :list="historyTransferList" :modalController="modalController"></HistoryTranferList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue'
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import HistoryRedeemReceiveList from '@/module/History/component/HistoryRedeem/List/HistoryRedeemReceiveList.vue';
import HistoryRedeemUseList from '@/module/History/component/HistoryRedeem/List/HistoryRedeemUseList.vue'
import HistoryTranferList from '../component/HistoryTranfer/HistoryTranferList.vue'
// import HistoryList from '@/module/History/component/HistoryList.vue';
import PathLink from '@/module/Detail/component/PathLink.vue';
import Menutab from '@/module/History/component/HistoryRedeem/MenuTab.vue'
import DateDropdown from "@/module/History/component/HistoryRedeem/InputSelectDate.vue"

//mixins
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import BzbsPoint from '@/core/Point/service/BzbsPoint.js';
// import Util from '@/helper/Utility.js';
import { HistoryPointConfigBuilder } from '@/core/Point/config/PointConfigModel.js';

import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';

export default {
    name: 'HistoryRedeem',
    mixins: [ModalMixin,LocaleMixin],
    components:{
        TopBar,
        TopBarBack,
        MenuDesktop,
        BottomBar,
        HistoryRedeemReceiveList,
        HistoryRedeemUseList,
        HistoryTranferList,
        // HistoryList,
        PathLink,
        Menutab,
        DateDropdown
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,
            paramsConfig: null,
            selectTab: 0,

            isSeeMoreEnable: false,
            isLoading: false,
            lastRowKey: null,
            filterDate: null,
            historyReceiveList: [],
            historyUseList: [],
            historyTransferList: [],
            isFirstLoad: true,
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.setupHistoryReceiveList(); //setup point list
        this.setupHistoryUseList(); //setup burn list
    },
    mounted: function(){ 
        //this.getHistoryUseList(); //burn list
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        //#region mixin
        onSetupModalCompleted: function() {
            this.initialHistoryModal();
        },
        //#endregion mixin
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryUseList: async function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .setSkip(0)
                .create();
            this.listConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.filterConfig = filterListConfig;
        },
        setupHistoryReceiveList: function(isClear){
            const month = this.setParamsSearchDate(this.filterDate)
            this.pointHistoryBuilder = new HistoryPointConfigBuilder()
                    .setMonth(month)
                    .setType(this.selectTab === 0 ? 'earn': 'burn')
                    .setTop(25)
                    .setLastRowKey(isClear ? '': this.lastRowKey)
                    .create()

            this.paramsConfig = this.pointHistoryBuilder.getParams();
        },

        loadMore: async function() {
            this.modalController.loadingModal.show();
            if(this.selectTab === 1){ //selectTab = 1 การใช้
                if(this.listConfig.isSeeMoreEnable && !this.isLoading){
                     await this.getHistoryUseList();
                     console.log('loadmore 1')
                }
            }
            else if(this.selectTab === 2){ //selectTab = 2 โอนคะแนน 
                if(!this.isLoading && this.isSeeMoreEnable){
                    this.setupHistoryReceiveList();
                    await this.getHistoryTranferList();
                    console.log('loadmore 3')
                }
            }else { //selectTab = 0 การได้รับ
                if(!this.isLoading && this.isSeeMoreEnable){
                    this.setupHistoryReceiveList();
                    await this.getHistoryReceiveList();
                    console.log('loadmore 2')
                }
            }
            this.modalController.loadingModal.hide();
        },
        getHistoryReceiveList: function() { //selectTab = 0 การได้รับ
            return new Promise((resolve) => {
                this.isLoading = true;
                this.loadingModal.show();
                BzbsPoint.apiGetPointLog(this.paramsConfig).subscribe({
                    next: (res) =>{ 
                        res.forEach((element) => { //points > 0 คือ การได้รับ point
                            this.historyReceiveList.push(element);
                            this.lastRowKey = element.rowKey
                        });
                        console.log('historyReceiveList', this.historyReceiveList);
                        this.isSeeMoreEnable = res.length ? true : false
                        this.loadingModal.hide();
                        this.isLoading = false;
                        resolve(res)
                    },
                    error: (err) => {
                        console.log(err)
                        this.isLoading = false;
                        this.isSeeMoreEnable = false;
                        this.loadingModal.hide();
                    }
                })
            });
        },
        getHistoryTranferList: function() { //selectTab = 2 โอนคะแนน
            return new Promise((resolve) => {
                this.isLoading = true;
                this.loadingModal.show();
                BzbsPoint.apiGetPointHistory(this.paramsConfig).subscribe({
                    next: (res) =>{ 
                        res.forEach((element) => { 
                            this.historyTransferList.push(element);
                            this.lastRowKey = element.rowKey
                        });
                        console.log('historyTransferList', this.historyTransferList);
                        this.isSeeMoreEnable = res.length ? true : false
                        this.loadingModal.hide();
                        this.isLoading = false;
                        resolve(res)
                    },
                    error: (err) => {
                        console.log(err)
                        this.isLoading = false;
                        this.isSeeMoreEnable = false;
                        this.loadingModal.hide();
                    }
                })
            });
        },
        getHistoryUseList: function () { //selectTab = 1 //การแลก
            return new Promise((resolve) => {
                this.isLoading = true;
                this.loadingModal.show();
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig)
                    .subscribe({
                        next: (purchases) => {
                            console.log('history list', purchases);
                            this.listConfig.increstSkip();
                            //check is there are more campaign.
                            if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                                this.listConfig.setSeeMoreEnable(false);
                            }
                            //reinitialize list if no skip.
                            if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                                this.historyUseList = [];
                            }

                            for (var purchase of purchases) {
                                //TODO: Add GA Tracking.
                                this.historyUseList.push(purchase);
                            }
                            this.isLoading = false;
                            this.isLoaded = true;
                            this.isHaveItem = this.historyUseList.length > 0 ? true : false;
                            this.loadingModal.hide();
                            resolve();
                        },
                        error: (err) => {
                            this.isLoading = false;
                            this.isLoaded = true;
                            this.isHaveItem = false;
                            this.loadingModal.hide();
                            this.errorApi(err);
                            resolve();
                        }
                });
            });
        },
        setParamsSearchDate: function(data){
            if(data){
                if(data.month && data.month.length === 1){
                data.month = '0' + data.month
            }
                let formatSearchMonth = data.year + '-' + data.month + '-01'
                return formatSearchMonth
            }else{
                const currentDate = new Date();
                let month = currentDate.getMonth() + 1;
                month = month.toString();
                let year = currentDate.getFullYear()
                if(month && month.length == 1){
                    month = '0' + month
                }
                return year + '-' + month + '-01';
            }
        },
        onSelectDate: async function(date){
            //console.log("onSelectDate", date);
            if (this.isFirstLoad) {
                this.isFirstLoad = false;
                return;
            }
            //console.log("onSelectDate", date);
            this.lastRowKey = "";
            this.filterDate = date;
            this.setupHistoryReceiveList(); //setup earn list
            if (this.selectTab === 0) {
                this.historyReceiveList = [];
                await this.getHistoryReceiveList(); //get earn list
            }
            else if(this.selectTab === 2) {
                this.historyTransferList = [];
                await this.getHistoryTranferList(); //get transfer list
            }
        },
        changeTabToGetHistoryRedeem: async function(tab){
            this.selectTab = tab
            //console.log('tab', tab)
            let isClear = true;
            if (tab === 0) {
                this.historyReceiveList = [];
                this.setupHistoryReceiveList(isClear); //setup earn list
                await this.getHistoryReceiveList(); //get earn list
            } else if(tab === 1) {
                this.historyUseList = []; 
                this.setupHistoryUseList(isClear); //setup burn list
                await this.getHistoryUseList(); //get burn list
            } else {
                this.historyTransferList = [];
                this.setupHistoryReceiveList(isClear); //setup earn list
                await this.getHistoryTranferList(); //get transfer list
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.bg-history {
    background-image: linear-gradient(to bottom, #1c3e95 2%, #1c3d91 2%, #1a326e 16%);
    @include mobile {
        background-color: #e9ecf5;
        background-image: none;
    }
}
.wrapper { 
    min-height: calc(100vh - 65px);
}
</style>
